import { Center, Skeleton } from '@chakra-ui/react';
import CustomDataTableEditBtn from '@Modules/core/components/table/CustomDataTableEditBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TCardCommissionDataTableData = {
  primaryKey: string | number,
  transactionCode: string,
  bankGroup: string,
  dc: string,
  ratio: number | string,
  fix: number | string,
  minimum: number | string,
  maximum: number | string,
  [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TCardCommissionDataTableData>();

export function getCardCommissionDataTableColumns({
  isLoading,
  handleEdit,
}: Props) {
  return [
    columnHelper.accessor('transactionCode', {
      id: 'transactionCode',
      header: 'Code Transaction',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('bankGroup', {
      id: 'bankGroup',
      header: 'Grp. Banque',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dc', {
      id: 'dc',
      header: 'D/C',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    // TODO: Format decimal number for all below cells
    columnHelper.accessor('ratio', {
      id: 'ratio',
      header: 'Taux',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('fix', {
      id: 'fix',
      header: 'Fixe',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('minimum', {
      id: 'minimum',
      header: 'Minimum',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('maximum', {
      id: 'maximum',
      header: 'Maximum',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <CustomDataTableEditBtn onClick={() => handleEdit(props.row)} />
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
